import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Info } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Today's Extra Information box.
 * Renders only when admin has posted a non-empty note for today's UK date.
 * Kept intentionally simple: plain text, whitespace preserved, centered.
 */
export default function TodaysExtraInfo() {
  const [text, setText] = useState("");

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/config/extra-info`)
      .then((r) => {
        if (alive) setText(r.data?.text || "");
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <AnimatePresence>
      {text && (
        <motion.section
          key="extra-info"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="mt-4 px-6"
          data-testid="todays-extra-info"
        >
          <div className="rounded-2xl border border-zinc-800 bg-zinc-900/60 px-5 py-4 text-center">
            <div className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.28em] text-[#E1FF00]">
              <Info size={12} />
              Today's Extra Information
            </div>
            <div
              className="mt-2 whitespace-pre-wrap text-sm leading-relaxed text-zinc-200"
              data-testid="todays-extra-info-text"
            >
              {text}
            </div>
          </div>
        </motion.section>
      )}
    </AnimatePresence>
  );
}
